import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class F1DriverStore extends LocalModel {
    constructor() {
        super('f1Driver', {
            namePlural: 'f1Drivers',
            namePluralReal: 'f1drivers',
            sort: 'championshipPosition',
            limit: 100,
            api: {
                search: {
                    url: '/api/f1drivers/',
                    params: {
                        limit: 100,
                        sort: 'championshipPosition',
                    },
                },
                load: {
                    url: '/api/f1drivers/',
                    params: {},
                },
                save: {
                    url: '/api/f1drivers/',
                    params: {},
                },
                delete: {
                    url: '/api/f1drivers/',
                    params: {},
                },
            },
        });
    }

    @observable f1Drivers = [];

    @observable f1Driver = {};

    @observable newF1Driver = {};
}

const store = new F1DriverStore();
export default store;
